import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Loader = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
        className="text-emerald-600 mb-6"
      >
        <SafeIcon icon={FiIcons.FiLoader} className="text-5xl" />
      </motion.div>
      
      <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">
        Analizando propiedad...
      </h3>
      <p className="text-gray-500 text-center max-w-sm">
        Nuestra IA está redactando la descripción perfecta y optimizando los hashtags para asegurar el mejor alcance.
      </p>

      <div className="mt-8 flex gap-2">
        {[1, 2, 3].map((i) => (
          <motion.div
            key={i}
            className="w-2.5 h-2.5 bg-emerald-400 rounded-full"
            animate={{ y: ["0%", "-50%", "0%"] }}
            transition={{ repeat: Infinity, duration: 0.6, delay: i * 0.15 }}
          />
        ))}
      </div>
    </div>
  );
};

export default Loader;